import { render } from "./approverTestResult.vue?vue&type=template&id=31cd1aa2&scoped=true"
import script from "./approverTestResult.vue?vue&type=script&lang=js"
export * from "./approverTestResult.vue?vue&type=script&lang=js"

import "./approverTestResult.vue?vue&type=style&index=0&id=31cd1aa2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31cd1aa2"]])

export default __exports__